(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-modouge-nomad"] && !Shopify.designMode) return;
  try {
    
(function(){
  var roots = document.querySelectorAll('.mdg');
  roots.forEach(function(root){
    // scroll reveal
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    },{threshold:.12, rootMargin:'0px 0px -8% 0px'});
    root.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });

    // temperature countdown
    var t = root.querySelector('[data-temp]');
    if(t){
      var target = parseInt(t.textContent,10) || 37;
      var v = target + 13;
      t.innerHTML = v + '<small>°F</small>';
      var tick = setInterval(function(){
        v--; t.innerHTML = v + '<small>°F</small>';
        if(v<=target){ clearInterval(tick); t.innerHTML = target + '<small>°F</small>'; }
      },70);
    }
  });

  // sticky buy bar
  var bar = document.querySelector('[data-buybar]');
  var hero = document.querySelector('[id^="mdg-buy-"]');
  if(bar && hero){
    var hio = new IntersectionObserver(function(ent){ bar.classList.toggle('show', !ent[0].isIntersecting); },{threshold:0});
    hio.observe(hero);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
